<style>
.v--modal-box.v--modal {
  min-width: 260px !important;
  min-height: 120px !important;
}
.v-list__tile {
  font-size: 14px !important;
  height: 34px !important;
}
.v-menu {
  z-index: 100;
}
.font--bold {
  font-weight: 700;
  font-size: 14px !important;
}
.font--primary {
  font-size: 12px !important;
}
.input__wrapper {
  padding-left: 0px !important;
}
.btn__modal {
  height: 25px;
  margin: 0 0 0 5px;
}
.v-btn__content {
  height: 25px;
  font-size: 12px;
}
.modal__container {
  padding: 0px;
}
.modal__header,
.modal__content,
.modal__footer {
  padding-left: 24px;
  padding-right: 24px;
}
.modal__header {
  border-bottom: 1px solid grey;
  height: 40px;
  background: #2a579a;
  color: #fff;
}
.modal__header span {
  line-height: 40px !important;
  text-transform: uppercase;
}
.modal__header button {
  height: 40px;
}
.modal__footer {
  margin-bottom: 24px;
  height: 50px;
}
.modal__content {
  height: calc(100% - 100px);
}
.success {
  background: #009e4f !important;
}
.error {
  background: #ff5b57 !important;
}
.primary--text {
  color: #2a579a !important;
  caret-color: #2a579a !important;
}
.modal__header__btn:focus {
  outline: 0;
}
.list__container {
  height: calc(100% - 112px);
  width: 100%;
  overflow-y: auto;
}
.list__container--el {
  border-bottom: 1px solid lightgrey;
  display: flex;
  justify-content: space-between;
  line-height: 32px;
  transition: all 0.2s;
  font-size: 12px;
  padding-left: 15px;
  padding-right: 15px;
}
.list__container--el:hover {
  background: lightgrey;
}
.card__icon--edit {
  opacity: 0.8;
  line-height: 40px;
  transition: all 0.2s;
}
.card__icon--edit:hover {
  opacity: 1;
}
.v-icon {
  cursor: pointer;
  transition: all 0.2s;
}
/*.v-icon:hover {
  color: rgba(0, 0, 0, 0.84);
  background: #3f67a4;
}*/
.v-btn--disabled {
  pointer-events: none;
}
@media only screen and (min-width: 1264px) {
  .container {
    max-width: none !important;
  }
}
@media only screen and (min-width: 960px) {
  .container {
    max-width: none !important;
  }
}
.modal__footer .v-icon {
  font-size: 24px !important;
}
.hidden__buttons {
  visibility: hidden;
}
.v-menu__content {
  z-index: 10001 !important;
}
</style>

<template>
  <modal
    :id="modalName"
    :name="modalName"
    style="z-index: 1"
    draggable=".modal__header"
    resizable
    :clickToClose="false"
    @opened="opened(modalName)"
    @closed="closed(modalName)"
    @resize="saveSize()"
    @before-open="loadSize()"
    :pivotX="0"
    :pivotY="0"
  >
    <v-container fill-height style="display: flex;" class="modal__container">
      <v-layout row wrap>
        <v-flex xs12 class="modal__header">
          <v-layout justify-space-between>
            <span class="font--bold">{{ title }}</span>
            <v-spacer></v-spacer>
            <button class="modal__header__btn" @click="$modal.hide(modalName)">
              <v-icon style="color: white;">close</v-icon>
            </button>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="modal__content">
          <slot></slot>
        </v-flex>
        <v-flex xs12 class="modal__footer">
          <v-layout row fill-height v-if="!register">
            <v-flex
              class="editing__buttons"
              xs10
              :class="{
                hidden__buttons:
                  (!(
                    $can('read', module + '_edit') ||
                    $can('edit', module) ||
                    module === 'canEditUserLayer'
                  ) &&
                    module != 'terminals' &&
                    module != 'variance' &&
                    module != 'curves') ||
                  isNewObject
              }"
            >
              <span v-if="editing == false">
                <span
                  class="editing__button--start"
                  @click="$emit('editingStart')"
                  title="Edytuj atrybuty obiektu"
                >
                  <v-icon class="table__btn--orange">edit</v-icon>
                </span>

                <!--<v-btn depressed class="btn__modal" color="warning" @click="$emit('editingStart')">Edycja</v-btn>-->
              </span>
              <span v-else-if="editing == true">
                <span
                  class="editing__button--cancel"
                  @click="$emit('editingCancel')"
                  title="Anuluj"
                >
                  <v-icon class="table__btn--red">cancel</v-icon>
                </span>
                <span
                  class="editing__button--save"
                  @click="$emit('editingSave')"
                  title="Zapisz"
                >
                  <v-icon class="table__btn--green">check_circle</v-icon>
                </span>
              </span>
              <div class="text--primary" v-else-if="addingRaster">
                <p style="color:grey">
                  Krok {{ addRasterStep }}/2 {{ addRasterDescription }}
                  <v-icon
                    v-if="addRasterStep == 1"
                    style="font-size: 14px !important"
                    title="Aby przejść do kroku drugiego zapisz raster w aplikacji"
                    >help</v-icon
                  >
                  <v-icon
                    v-else
                    style="font-size: 14px !important"
                    title="Możesz zapisać raster"
                    >help</v-icon
                  >
                </p>
              </div>
              <span>
                <span
                  class="editing__button--zoom"
                  @click="$emit('zoom')"
                  title="Przybliż"
                  v-if="zoom__left"
                >
                  <v-icon class="table__btn">zoom_in</v-icon>
                </span>
                <span
                  class="editing__button--print"
                  @click="$emit('print')"
                  title="Generuj raport"
                  v-if="print__left"
                >
                  <v-icon class="table__btn--blue">print</v-icon>
                </span>
              </span>
            </v-flex>
            <v-flex class="buttons__right" xs2 v-if="!hideButtons__right">
              <v-layout justify-end align-end fill-height>
                <div v-for="button in buttons" :key="button">
                  <div
                    v-bind:class="{ hide: isHidden }"
                    v-if="button === 'save'"
                  >
                    <span
                      class="group pa-2"
                      title="Zapisz"
                      id="saveBtn"
                      @click="$emit('saved')"
                    >
                      <v-icon class="table__btn--blue">check_circle</v-icon>
                    </span>
                  </div>
                  <div
                    v-bind:class="{ hide: isHidden }"
                    v-if="button === 'sendMobile'"
                  >
                    <span
                      class="group pa-2"
                      title="Wyślij"
                      id="saveBtn"
                      @click="$emit('saved')"
                    >
                      <v-icon>phonelink_ring</v-icon>
                    </span>
                  </div>

                  <div v-else-if="button === 'continue'">
                    <span
                      class="group pa-2"
                      title="Kontynuuj"
                      @click="$modal.hide(modalName)"
                    >
                      <v-icon>check_circle</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'clearLocaleStyles'">
                    <v-icon
                      @click="clearLocaleStyles()"
                      title="Wyczyść lokalne style"
                      >delete</v-icon
                    >
                  </div>
                  <div v-else-if="button === 'iconUploaderOpen'">
                    <v-icon
                      @click="iconUploaderOpen()"
                      title="Dodaj nowe ikony"
                      v-if="isAdminSymbolization"
                      >add_circle_outline</v-icon
                    >
                  </div>
                  <div v-else-if="button === 'addDissabled'">
                    <v-btn
                      depressed
                      class="btn__modal v-btn--disabled"
                      id="btn__modal--addDissabled"
                      color="success"
                      @click="$emit('add')"
                    >
                      <v-icon>add_circle_outline</v-icon>
                    </v-btn>
                  </div>
                  <div v-else-if="button === 'add'">
                    <span
                      id="addBtn"
                      class="group pa-2"
                      title="Dodaj"
                      @click="$emit('add')"
                    >
                      <v-icon>check_circle</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'addGeoserver'">
                    <span
                      id="addGeoserverBtn"
                      class="group pa-2"
                      title="Dodaj raster do geoservera"
                      @click="$emit('addGeoserver')"
                    >
                      <v-icon>check_circle</v-icon>
                    </span>
                  </div>
                  <div
                    v-bind:class="{ hide: isHidden }"
                    v-else-if="button === 'cancel'"
                  >
                    <span
                      class="group pa-2"
                      title="Anuluj"
                      @click="$modal.hide(modalName)"
                    >
                      <v-icon>highlight_off</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'clear'">
                    <span
                      class="group pa-2"
                      title="Wyczyść"
                      @click="$emit('cleared')"
                    >
                      <v-icon>remove_circle</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'ok'">
                    <v-btn
                      depressed
                      class="btn__modal"
                      color="success"
                      @click="$modal.hide(modalName)"
                      >OK</v-btn
                    >
                  </div>
                  <div v-else-if="button === 'saveHydrantsAddInspection'">
                    <v-btn
                      depressed
                      class="btn__modal"
                      color="success"
                      @click="$root.$emit('addInspection')"
                      >DODAJ</v-btn
                    >
                  </div>
                  <div v-else-if="button === 'saveHydrantsEditInspection'">
                    <v-btn
                      depressed
                      class="btn__modal"
                      color="success"
                      @click="$root.$emit('editInspection')"
                      >DODAJ</v-btn
                    >
                  </div>
                  <div v-else-if="button === 'AddInspectionCard'">
                    <v-btn
                      depressed
                      class="btn__modal"
                      color="success"
                      @click="$emit('addInspectionCard')"
                      >DODAJ</v-btn
                    >
                  </div>

                  <div
                    v-else-if="button === 'deleteDict' && username == 'aquagis'"
                  >
                    <span
                      class="group pa-2 v-btn--disabled"
                      id="btn__modal--remove"
                      title="Usuń słownik"
                      @click="removeDict"
                    >
                      <v-icon>delete_forever</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'editDict'">
                    <span
                      class="group pa-2 v-btn--disabled"
                      id="btn__modal--edit"
                      title="Edytuj słownik"
                      @click="openModal('editDictionaryModal')"
                    >
                      <v-icon>edit</v-icon>
                    </span>
                  </div>
                  <div
                    v-else-if="button === 'addDict' && username == 'aquagis'"
                  >
                    <span
                      class="group pa-2"
                      id="btn__modal--add"
                      title="Dodaj słownik"
                      @click="openModal('addDictionaryModal')"
                    >
                      <v-icon>add_box</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'addFieldModal'">
                    <span
                      class="group pa-2 v-btn--disabled"
                      id="btn__modal--addField"
                      title="Dodaj pole słownikowe"
                      @click="openModal('addFieldModal')"
                    >
                      <v-icon>add_box</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'addField'">
                    <span
                      class="group pa-2 v-btn--disabled"
                      id="btn--addField"
                      title="Dodaj pole słownikowe"
                      @click="addField"
                    >
                      <v-icon>check_circle</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'addTaskModal'">
                    <span
                      class="group pa-2"
                      id="btn__modal--addTaskModal"
                      title="Dodaj harmonogram"
                      @click="openModal('addTaskModal')"
                    >
                      <v-icon>add_box</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'editSchedule'">
                    <span
                      class="group pa-2 v-btn--disabled"
                      id="btn--editSchedule"
                      title="Edytuj harmonogram"
                      @click="editSchedule"
                    >
                      <v-icon>check_circle</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'addTask'">
                    <span
                      class="group pa-2"
                      id="btn__modal--addTask"
                      title="Dodaj harmonogram"
                      @click="addTask"
                    >
                      <v-icon>add_box</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'deleteField'">
                    <v-btn
                      depressed
                      class="btn__modal v-btn--disabled"
                      id="btn--deleteField"
                      color="error"
                      title="Usuń pole"
                      @click="deleteField"
                      >Usuń pole</v-btn
                    >
                  </div>

                  <div
                    v-else-if="button === 'print'"
                    :class="{
                      print__display: isHiddenPrint,
                      hidden__buttons: !$can('read', module + '_reports')
                    }"
                  >
                    <span
                      class="group pa-2"
                      id="btn--print"
                      title="Wydrukuj"
                      @click="$emit('print')"
                    >
                      <v-icon class="table__btn--blue">print</v-icon>
                    </span>
                  </div>
                  <!-- temp fix -->
                  <div
                    v-else-if="button === 'print2'"
                    :class="{ print__display: isHiddenPrint }"
                  >
                    <span
                      class="group pa-2"
                      id="btn--print"
                      title="Wydrukuj"
                      @click="$emit('print')"
                    >
                      <v-icon class="table__btn--blue">print</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'zoom'" :class="{}">
                    <span
                      class="group pa-2"
                      id="btn--zoom"
                      title="Przybliż"
                      @click="$emit('zoom')"
                    >
                      <v-icon class="table__btn--blue">zoom_in</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'info'">
                    <span
                      class="group pa-2"
                      id="btn--info"
                      title='Do raportu zaliczają się obiekty z sieci wodociągowej o atrybucie "Rodzaj sieci" = "Ogólny" oraz z sieci kanalizacyjnej o atrybucie "Zakres sieci" = "Ogólny"'
                    >
                      <v-icon>info</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'report'">
                    <span
                      class="group pa-2"
                      id="btn--report"
                      title="Generuj raport"
                      @click="$emit('report')"
                    >
                      <v-icon>description</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'export'">
                    <span
                      class="group pa-2"
                      id="btn--export"
                      title="Pobierz dane w formacie CSV"
                      @click="$emit('export')"
                    >
                      <v-icon>get_app</v-icon>
                    </span>
                  </div>
                  <div v-else-if="button === 'clipboardNotice'">
                    <span
                      class="group pa-2"
                      id="btn--clipboard-notice"
                      title="Skopiuj treść do schowka w formacie HTML"
                      @click="$emit('copyToClipboard')"
                    >
                      <v-icon>file_copy</v-icon>
                    </span>
                  </div>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </modal>
</template>

<script>
export default {
  props: {
    modalName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: false
    },
    buttons: {
      type: Array,
      required: false,
      default: () => {
        return ["save", "cancel"];
      }
    },
    editing: {
      type: Boolean,
      required: false,
      default: () => undefined
    },
    isHidden: {
      type: Boolean,
      required: false
    },
    isHiddenPrint: {
      type: Boolean,
      required: false
    },
    addingRaster: {
      type: Boolean,
      required: false
    },
    addRasterStep: {
      type: Number,
      required: false
    },
    addRasterDescription: {
      type: String,
      required: false
    },
    register: {
      type: Boolean,
      required: false
    },
    isNewObject: {
      type: Boolean,
      required: false
    },
    hideButtons__right: {
      type: Boolean,
      required: false
    },
    print__left: {
      type: Boolean,
      required: false
    },
    zoom__left: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    pivX: 0,
    pivY: 0,
    isAdminSymbolization: false,
    username: undefined
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  mounted() {
    this.$root.$on("changeAdminSymbolization", this.changeAdminSymbolization);
    this.username = localStorage.username;
  },
  methods: {
    openModal(name) {
      this.$nextTick(() => {
        this.show(name);
      });
    },
    changeAdminSymbolization(data) {
      this.isAdminSymbolization = data;
    },
    clearLocaleStyles() {
      this.$emit("clearLocaleStyles");
    },
    iconUploaderOpen() {
      this.$emit("iconUploaderOpen");
    },
    removeDict() {
      this.$emit("removeDict", this.$store.getters.getCurrentEditedDict["id"]);
    },
    addField() {
      this.$emit("addField");
    },
    addTask() {
      this.$emit("addTask");
    },
    editSchedule() {
      this.$emit("editSchedule");
    },
    deleteField() {
      this.$emit("deleteField");
    },
    opened(modalName) {
      this.refreshView();
      this.$emit("opened");
      this.$el
        .querySelector(".v--modal-box")
        .addEventListener("mousedown", this.refreshView);
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    refreshView() {
      for (let i in this.activeModals) {
        if (document.getElementById(this.activeModals[i])) {
          if (this.activeModals[i] == this.$el.id) {
            document.getElementById(this.activeModals[i]).style.zIndex =
              this.activeModals.length + 1000;
          } else {
            document.getElementById(this.activeModals[i]).style.zIndex = i + 2;
          }
        }
      }
    },
    // Customowe rozmiary modala
    saveSize() {
      let el = this.$el.getElementsByClassName("v--modal-box")[0];
      if (el) {
        let height = getComputedStyle(el).height;
        let width = getComputedStyle(el).width;
        let top = getComputedStyle(el).top;
        let left = getComputedStyle(el).left;
        localStorage[this.$el.id] = JSON.stringify({
          height: height,
          width: width,
          top: top,
          left: left
        });
      }
    },
    // Customowe rozmiary modala
    loadSize() {
      if (localStorage[this.modalName] !== undefined) {
        let size = JSON.parse(localStorage[this.modalName]);
        this.$children[0].modal.width = parseInt(size.width.split("px"));
        this.$children[0].modal.widthType = "px";
        this.$children[0].modal.height = parseInt(size.height.split("px"));
        this.$children[0].modal.heightType = "px";
        this.$children[0].shift.top = parseInt(size.top.split("px"));
        this.$children[0].shift.left = parseInt(size.left.split("px"));
      } else {
        this.$children[0].shift.top =
          window.innerHeight / 2 - this.$children[0].modal.height / 2;
        this.$children[0].shift.left =
          window.innerWidth / 2 - this.$children[0].modal.width / 2;
      }
    },
    closed(modalName) {
      this.saveSize();
      this.$store.commit("removeModal", modalName);
      this.$emit("closed");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue